import { InputTextWithIconAccordionProps } from "./types"
import React from "react"
import { Image } from "~/ui/primitives"
import styled from '~/ui/styled'
import { Text as TextCore } from "~widgets/text"

const Wrap = styled.View`
  flex-direction: row;
  background-color: #fff;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
`
const Input = styled.TextInput`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.text};
  height: 50px;
`
const Text = styled(TextCore)`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.text};
`
const InputTextWithIconAccordion: React.FC<InputTextWithIconAccordionProps> = ({
  accordionProps,
  inputTextProps,
  imageSrc,
}) => {
  return (
    <Wrap {...accordionProps}>
      <Image src={imageSrc} style={{ width: 20, height: 20, marginHorizontal: 5 }} />
      <Text>{accordionProps?.label}</Text>
      <Input {...inputTextProps} style={{ flex: 1, textAlign: "right" }}></Input>
    </Wrap>
  )
}
export default InputTextWithIconAccordion
